/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Grid, Button } from "@mui/material";
import { green, purple, orange } from "@mui/material/colors";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";

import BackspaceIcon from "@mui/icons-material/Backspace";

const theme = createTheme({
  status: {
    danger: orange[500],
  },
});

const DigitButton = styled(Button)(({ theme }) => ({
  width: "100%",
  height: "50px",
  fontSize: "1.5rem",
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: green[500],
  "&:hover": {
    backgroundColor: green[700],
  },
}));

const EnterButton = styled(Button)(({ theme }) => ({
  width: "100%",
  height: "50px",
  fontSize: "1rem",
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: orange[500],
  "&:hover": {
    backgroundColor: orange[700],
  },
}));

let prevKeyTime = 0;
export default function PDigitPanel(props) {
  const [digits, setDigits] = useState("");

  function onKeyPressed(value) {
    props.onKeyPressed(value);
  }
  return (
    <ThemeProvider theme={theme}>
      <Grid container style={{ width: "100%" }}>
        <Grid item xs={12}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("1");
                    }}
                  >
                    1
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("2");
                    }}
                  >
                    2
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("3");
                    }}
                  >
                    3
                  </DigitButton>
                </td>
              </tr>
              <tr>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("4");
                    }}
                  >
                    4
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("5");
                    }}
                  >
                    5
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("6");
                    }}
                  >
                    6
                  </DigitButton>
                </td>
              </tr>
              <tr>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("7");
                    }}
                  >
                    7
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("8");
                    }}
                  >
                    8
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("9");
                    }}
                  >
                    9
                  </DigitButton>
                </td>
              </tr>
              <tr>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed(".");
                    }}
                    disabled={props.disableDot}
                  >
                    .
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("0");
                    }}
                  >
                    0
                  </DigitButton>
                </td>
                <td>
                  <EnterButton
                    onClick={() => {
                      onKeyPressed("Backspace");
                    }}
                  >
                    <BackspaceIcon />
                  </EnterButton>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
